import React from "react";
import {
	Box,
	Typography,
	IconButton,
	Stack,
	Divider,
	Tooltip,
	Accordion,
	AccordionDetails,
	AccordionSummary,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ExpandMore } from "@mui/icons-material";

export const ResumeCard = ({
	resumeCardRef,
}: {
	resumeCardRef: React.RefObject<HTMLDivElement>
}) => {
	const url = "/CallumMackenzieResume.pdf";
	const fileNameHint = "CallumMackenzieResume.pdf";
	const height = 720;

	function openInNewTab() {
		if (!url) return;
		window.open(url, "_blank", "noopener,noreferrer");
	}

	function download() {
		if (!url) return;
		const a = document.createElement("a");
		a.href = url;
		a.download = fileNameHint;
		document.body.appendChild(a);
		a.click();
		a.remove();
	}

	return (
		 <Stack ref={resumeCardRef} className="resume-card" sx={{ width: '100%' }} >
			<Accordion defaultExpanded={false}>
				<AccordionSummary
					expandIcon={<ExpandMore sx={{ color: 'white' }} />}>
					<Stack className="resume-summary" direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
						<Stack direction="row" spacing={1} alignItems="center">
							<PictureAsPdfIcon />
							<Typography variant="h6">Resume</Typography>
						</Stack>
					</Stack>
				</AccordionSummary>

				<Divider />

				<AccordionDetails className="resume-details">
					<	Box sx={{ flex: 1, minHeight: height, borderRadius: 2, overflow: "hidden", border: 1, borderColor: "divider" }}>
						{url ? (
							<Box sx={{ height: height, position: "relative", bgcolor: "background.default" }}>
								<embed src={url} type="application/pdf" width="100%" height="100%" />
								<Box sx={{ position: "absolute", bottom: 8, right: 8, display: "flex", gap: 1 }}>
									<Tooltip title="Open full screen">
										<IconButton color="primary" onClick={openInNewTab}>
											<VisibilityIcon />
										</IconButton>
									</Tooltip>
									<Tooltip title="Download">
										<IconButton color="primary" onClick={download}>
											<DownloadIcon />
										</IconButton>
									</Tooltip>
								</Box>
							</Box>
						) : (
							<EmptyState height={height} />
						)}
					</Box>
				</AccordionDetails>
			</Accordion>
		</Stack >
	);
}

function EmptyState({ height = 720 }: { height?: number }) {
	return (
		<Box
			sx={{
				height,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				gap: 1,
				bgcolor: "background.paper",
			}}
		>
			<PictureAsPdfIcon sx={{ fontSize: 48, opacity: 0.6 }} />
			<Typography variant="subtitle1">Resume URL not set</Typography>
			<Typography variant="body2" color="text.secondary">
				Pass your PDF URL with the <code>url</code> prop to preview and download.
			</Typography>
		</Box>
	);
}
